import React, { useCallback } from "react";
import { Stack, Typography } from "@mui/material";

import { useFormatDateHook } from "hooks";
import { useUserActions } from "store";
import { INotification } from "store/types";
import { useClickHandler } from "hooks/notifications-hooks/use-click-handler";
import { NotificationMenu } from "../Notification-menu/NotificationMenu";
import { NotificationIcon } from "../Notification-icon/NotificationIcon";

interface NotificationsItemProps {
  notification: INotification;
  closeList: () => void;
}

export const ListItem: React.FC<NotificationsItemProps> = ({ notification, closeList }) => {
  const { id, read_at } = notification;
  const { updateNotificationsAction, deleteNotificationAction } = useUserActions();
  const formatDate = useFormatDateHook();

  const markAsRead = useCallback(() => {
    updateNotificationsAction(id, "read");
  }, [id, updateNotificationsAction]);

  const markAsUnread = useCallback(() => {
    updateNotificationsAction(id, "unread");
  }, [id, updateNotificationsAction]);

  const removeNotification = useCallback(() => {
    deleteNotificationAction(id);
  }, [id, deleteNotificationAction]);

  const notificationClickHandler = useClickHandler();
  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        minHeight: "88px",
        gap: "12px",
        p: "12px 20px",
        alignItems: "stretch",
        borderBottom: "1px solid #c7c7c7",
        bgcolor: read_at ? "white" : "#d8e8e9"
      }}
    >
      <NotificationIcon type={notification.action} />
      <Stack
        sx={{ justifyContent: "space-between", flexGrow: 1, cursor: "pointer" }}
        onClick={() => {
          if (!read_at) {
            markAsRead();
          }
          notificationClickHandler(notification);
          closeList();
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            color: "#597380",
            overflow: "hidden"
          }}
          dangerouslySetInnerHTML={{ __html: `<p>${notification.text}</p>` }}
        />
        <Typography sx={{ fontSize: "12px", color: "#8a9ca5" }}>
          {formatDate({ date: notification.created_at, format: "HH:mm, MMM DD, YYYY" })}
        </Typography>
      </Stack>
      <NotificationMenu remove={removeNotification} {...(notification.read_at ? { markAsUnread } : { markAsRead })} />
    </Stack>
  );
};
